exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-container-3MWkm{--uib-size:40px;--uib-speed:2s;--uib-bg-opacity:0;--fallback-size-loader:40px;width:var(--size-loader,var(--fallback-size-loader));height:var(--size-loader,var(--fallback-size-loader));transform-origin:center;animation:style-cssmodule-rotate-2fEOr var(--uib-speed) linear infinite;will-change:transform;overflow:visible}.style-cssmodule-car-MBEIr{fill:none;stroke:currentColor;stroke-dasharray:1,200;stroke-dashoffset:0;stroke-linecap:round;animation:style-cssmodule-stretch-1Bjvr calc(var(--uib-speed) * .75) ease-in-out infinite;will-change:stroke-dasharray,stroke-dashoffset;transition:stroke .5s ease}.style-cssmodule-track-2kFQe{fill:none;stroke:currentColor;opacity:var(--uib-bg-opacity);transition:stroke .5s ease}@keyframes style-cssmodule-rotate-2fEOr{to{transform:rotate(1turn)}}@keyframes style-cssmodule-stretch-1Bjvr{0%{stroke-dasharray:0,150;stroke-dashoffset:0}50%{stroke-dasharray:75,150;stroke-dashoffset:-25}to{stroke-dashoffset:-100}}", ""]);

// exports
exports.locals = {
	"container": "style-cssmodule-container-3MWkm",
	"rotate": "style-cssmodule-rotate-2fEOr",
	"car": "style-cssmodule-car-MBEIr",
	"stretch": "style-cssmodule-stretch-1Bjvr",
	"track": "style-cssmodule-track-2kFQe"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./components/loaders/Spinner/style.cssmodule.css
// module id = 2536
// module chunks = 121